import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 材料列表
 */
export function getMaterialInfoList(data) {
  return fetch ({
    url: '/repair/materialInfo/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除材料
 */
export function deleteMaterialInfo(data) {
  return fetch ({
    url: '/repair/materialInfo/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存材料
 */
export function saveMaterialInfo(data) {
  return fetch ({
    url: '/repair/materialInfo/save',
    method: 'POST',
    data
  })
}
/**
 * 上传附件
 * 
 */
export function uploadFile(data) {
  return fetch({
    url: '/foreign/storage/uploadFile',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/Material/index.js